import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import { openAppStoreWithOpenAIAds } from '../lib/openaiAds';
import AppStoreQrHover from './AppStoreQrHover';

const Navbar = ({ autoHideOnScroll = true }: { autoHideOnScroll?: boolean }) => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  const handleWaitlistClick = () => {
    openAppStoreWithOpenAIAds('navbar_try_for_free');
  };

  useEffect(() => {
    if (!autoHideOnScroll) return;
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Update scrolled state for background effect
      setIsScrolled(currentScrollY > 50);
      
      if (currentScrollY < lastScrollY || currentScrollY <= 0) {
        setIsNavbarVisible(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsNavbarVisible(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY, autoHideOnScroll]);

  return (
    <nav className={`navbar ${!autoHideOnScroll || isNavbarVisible ? 'navbar-visible' : 'navbar-hidden'} ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="nav-content">
        <Link to="/">
          <span className="uncling-text-logo">uncling</span>
        </Link>
        <div className="nav-links-center">
          <Link to="/attachment-style-quiz" className="nav-link-custom">Quiz</Link>
          <Link to="/blog" className="nav-link-custom">Blog</Link>
          <Link to="/careers" className="nav-link-custom">Careers</Link>
          <Link to="/about" className="nav-link-custom">About Us</Link>
          <Link to="/contact" className="nav-link-custom">Support</Link>
        </div>
        <AppStoreQrHover placement="bottom">
          <button className="download-button" onClick={handleWaitlistClick}>Try For Free</button>
        </AppStoreQrHover>
      </div>
    </nav>
  );
};

export default Navbar;
